import DispensaryProductPage from 'src/dispensary/product';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

DispensaryProductPage.layout = CoreMenuLayout;
export default DispensaryProductPage;
